<template lang="">
  <div>
    <el-dialog
      title="容器"
      :visible.sync="dialogVisible"
      width="540px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" :rules="rules">
        <el-form-item label="容器类型" prop="containerType">
          <el-radio-group v-model="form.containerType">
            <el-radio :label="1">拣货容器</el-radio>
            <el-radio :label="2">分拣容器</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="容器编号" prop="containerCode">
          <el-input
            v-model="form.containerCode"
            placeholder="请输入"
            maxlength="12"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="容量"
          prop="capacityType"
          v-if="form.containerType == 2"
        >
          <el-radio-group v-model="form.capacityType">
            <el-radio :label="2">4层5框</el-radio>
            <el-radio :label="1">5层4框</el-radio>
            <el-radio :label="3">4层4框</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="容器前缀"
          prop="childContainerCodes"
          v-if="form.containerType == 2"
        >
          <el-input
            v-model="form.childContainerCodes"
            placeholder="请输入"
            maxlength="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        class="listBox"
        v-if="childContainerList"
        :style="{ width: form.capacityType == 2 ? '500px' : '400px' }"
      >
        <div class="listItem" v-for="i in childContainerList" :key="i">
          <span>{{ i }}</span>
        </div>
      </div>
      <div style="margin-top: 10px">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { containerCreate } from "@/apis/configure";
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        containerType: 1,
        capacityType: 2,
      },
      rules: {
        containerType: [{ required: true }],
        containerCode: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]*$/g;
              if (!value) {
                callback(new Error("请输入容器编号"));
              } else if (!reg.test(value)) {
                callback(new Error("英文+数字，不支持特殊符号"));
              } else {
                callback();
              }
            },
          },
        ],
        capacityType: [{ required: true }],
        childContainerCodes: [{ required: true, message:'请输入正确的容器前缀' }],
      },
    };
  },
  computed: {
    childContainerListLength: function() {
      return this.form.capacityType == 3 ? 16 : 20
    },
    childContainerList: function () {
      let list = [];
      for (let i = 0; i < this.childContainerListLength; i++) {
        // let str = i < 9 ? `00${i + 1}` : `0${i + 1}`;
        list.push(this.form.childContainerCodes + String(i + 1));
      }
      return this.form.childContainerCodes && list;
    },
  },
  methods: {
    open() {
      (this.form = {
        containerType: 1,
        capacityType: 2,
      }),
        (this.dialogVisible = true);
      setTimeout(() => {
        this.clearValid();
      }, 0);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          Object.keys(this.form).map((v) => {
            if (this.form[v]) {
              params[v] = this.form[v];
            }
          });
          if (params.containerType == 1) {
            delete params.capacityType;
          }
          params.childContainerCodes &&
            (params.childContainerCodes = this.childContainerList);
          containerCreate({ ...params }).then((res) => {
            if (res.code == 0) {
              this.$message.success("成功");
              this.$emit("refresh");
              this.dialogVisible = false;
            }
          });
        }
      });
    },
    clearValid() {
      console.log("clearValid");
      this.$refs.form.clearValidate();
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item__content {
  text-align: left;
}
::v-deep .el-input {
  width: 200px;
}

.listBox {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
}

.listItem {
  height: 40px;
  width: 100px;
  box-sizing: border-box;
  background-color: #eee;
  border: 1px solid #999;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
